import colors from 'assets/theme/base/colors';

const { secondary } = colors;

const appBar = {
    styleOverrides: {
        root: {
            backgroundColor: secondary.light,
            boxShadow: 'none',
            filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))',
            //WhiteSpace: 'nowrap',
            //padding: `${pxToRem(10)} ${pxToRem(24)}`,
            //backdropFilter: `blur(${pxToRem(10)})`,
        },
    },
};

export default appBar;
